export interface ShoppingStats {
    FirstName: string;
    LastName: string;
    CouponsClipped: number;
    CouponsRedeemed: number;
    ProductsPurchased: number;
}
